import InputTypesEnum from '../../Enums/InputTypesEnum';

/**
 * Presentation groupings used by `InputWithClearBase` to decide which chrome
 * (clear button, label, wrapper) an input type gets. These were previously
 * inlined as anonymous arrays inside three separate methods; naming them here
 * keeps the behaviour in one place and self-documenting.
 */

/** Types that never show the clear ("eraser") button. */
export const TYPES_WITHOUT_ERASER = [
  InputTypesEnum.OnOff,
  InputTypesEnum.SingleCheckBox,
  InputTypesEnum.PlaceHolder,
  InputTypesEnum.MultiChoice,
  InputTypesEnum.Checkbox,
  InputTypesEnum.EmptySpace,
  InputTypesEnum.ClientMultiChoice,
  InputTypesEnum.ClientMultiChoiceAll,
  InputTypesEnum.DataFlowMapMultiChoice,
  InputTypesEnum.CountryMultiChoice,
  InputTypesEnum.ServiceCountryMultiSelect,
  InputTypesEnum.CountryCodeMultiChoice,
  InputTypesEnum.CountryNameMultiChoice,
  InputTypesEnum.ThirdPartySourceMultiChoice,
  InputTypesEnum.ThirdPartySourceEvaluatorMultiChoice,
  InputTypesEnum.PlatformMultiChoice,
  InputTypesEnum.Notes,
  InputTypesEnum.TextReadOnly,
  InputTypesEnum.FileUploadField,
  InputTypesEnum.CaspianRolesMultiCheck,
  InputTypesEnum.TextBoxReadOnly,
  InputTypesEnum.SourceQuestionSelect,
  InputTypesEnum.FieldworkPeriodApplyTable,
  InputTypesEnum.PillSelect,
  InputTypesEnum.InfoCallout,
  InputTypesEnum.FieldworkPeriodDateTable,
  InputTypesEnum.CountryPlanningTable,
  InputTypesEnum.TargetRate,
  // The value IS the link (e.g. the download-template href) — erasing it just breaks the anchor.
  InputTypesEnum.Link,
  // Its + Month / + Year buttons sit where the eraser would, and the preview and note run under the whole row.
  InputTypesEnum.InvoiceReferenceTemplate,
  // The chosen contact's details run under the select, so an eraser would stand beside the whole block.
  InputTypesEnum.InvoiceBillToContactSelect,
  // The shops it asks about are listed under the select, so an eraser would stand beside the whole block.
  InputTypesEnum.JobsNoLongerReadyChoiceSelect,
];

/** Types that render without the field label. */
export const TYPES_WITHOUT_LABEL = [
  InputTypesEnum.EmptySpace,
  InputTypesEnum.MultiChoice,
  InputTypesEnum.Text2,
  InputTypesEnum.SingleCheckBox,
  InputTypesEnum.InfoCallout,
];

/** Types that render the bare input only — no surrounding label/eraser/error chrome. */
export const TYPES_RENDERED_WITHOUT_CHROME = [
  InputTypesEnum.Text2,
  InputTypesEnum.SingleCheckBox,
  InputTypesEnum.TextBox2,
  InputTypesEnum.NumberWithTwoDecimalPlaces2,
  InputTypesEnum.Number2,
  InputTypesEnum.EmptyYesNoSelect2,
  InputTypesEnum.Select2,
  // Reads nothing and validates nothing — it is a notice, not a field. With the chrome it
  // was laid out as a labelled control, so it sat in the control's three quarters of the
  // card with an empty label column beside it instead of spanning the width it was given.
  InputTypesEnum.InfoCallout,
];
